module.exports = __webpack_public_path__ + "img/logo.ee80fe17.png";